// extracted by mini-css-extract-plugin
export var meControlMiniAvatarStyle = "qeGMt";